import React, {useState, FormEvent, useContext} from "react"
import {useMutation} from "@apollo/client"
import {Search} from "../Tmdb/Search"

import movieAdd from "graphql/Media/Movie/mutation/movieAdd"
import {alertContext} from "context/Alert/alert"
import {BackofficePage, BackofficePanel} from "components/backoffice/Layout/BackofficePage"

export const MovieEdit = (props: any) => {

  const [mutate] = useMutation(movieAdd)

  const {setMessage, setError} = useContext(alertContext)
  const [movie, updateMovie] = useState<any>(null)

  const onChange = (name: string, tmdbOptions: any) => {
    updateMovie({
      name,
      tmdbOptions,
    })
  }

  const onSubmit = (e: FormEvent) => {
    e.preventDefault()
    mutate({
      variables: {
        input: {
          ...movie,
        }
      }
    })
      .then(() => {
        setMessage("Film ajouté au catalogue")
      })
      .catch(() => {
        setError("Impossible d'ajouter ce film")
      })
  }

  return <BackofficePage eyebrow="Catalogue" title="Ajouter un film" description="Associez le film à sa fiche TMDB pour récupérer ses métadonnées." icon="fa-film">
    <BackofficePanel title="Recherche TMDB" description="Sélectionnez la fiche officielle correspondant au film." icon="fa-search">
      <form className="bo-media-create-form" onSubmit={onSubmit}>
        <div className="bo-form-column">
          <Search
            type='movie'
            onChange={onChange}
          />
          {movie?.name && <div className="bo-selection-confirmation"><span className="fas fa-check"></span><span><small>Film sélectionné</small><strong>{movie.name}</strong></span></div>}
          <button className="bo-primary-action" disabled={!movie}><span className="fas fa-plus"></span>Ajouter le film</button>
        </div>
      </form>
    </BackofficePanel>
  </BackofficePage>
}
